import gql from 'graphql-tag'

export default gql`mutation ycmdUserCreate($user: ImportUser) {
	ycmdUserCreate(user: $user) {
		username
	}
}`
